import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reports: [],
};

const dashboard = createSlice({
  name: "report",
  initialState,
  reducers: {
    updateObject: (state, action) => {
      state.reports = action.payload;
    },

    clearState: (state) => {
      state.reports = [];
    },
  },
});

export const { updateObject, clearState } = dashboard.actions;
export default dashboard.reducer;
